import {
  Box,
  Button,
  Group,
  InputLabel,
  Stack,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useCampaignStore } from "../../../stores/CampaignStore";
import { TimeInput } from "@mantine/dates";
import { useLanguage } from "../../../stores/LanguageStore";
import DailySchedule from "../workflows/CreateCampaign/campaignSettings/DailySchedule"; // 👈 1. Import the new component

const NewsletterTimeIntervalSettings = ({ item, programData, setProgramData }) => {
  const lang = useLanguage((s) => s.language);
  const timeStartGlobal = useCampaignStore((s) => s.timeStart);
  const timeStopGlobal = useCampaignStore((s) => s.timeStop);

  const [timeStart, setTimeStart] = useState(
    programData?.["time_start_sending_" + item.value.split("_")[1]]
  );
  const [timeStop, setTimeStop] = useState(
    programData?.["time_stop_sending_" + item.value.split("_")[1]]
  );

  // No changes needed to these handlers
  const handleStartChange = (newValue) => {
    setTimeStart(newValue);
  };
  const handleStopChange = (newValue) => {
    setTimeStop(newValue);
  };

  return (
    <>
      <Stack key={item.value} align="start">
        <Group>
          <Box
            style={{
              border: "1px solid",
              borderRadius: 600,
              borderColor: programData?.[item.value]
                ? "var(--mantine-color-primary-4)"
                : "#00000033",
            }}
            p={4}
          >
            <Button
              size={"sm"}
              key={item.value}
              variant={programData?.[item.value] ? "filled" : "subtle"}
              onClick={() => {
                setProgramData({
                  ...programData,
                  [item.value]: programData?.[item.value] ? false : true,
                });
              }}
              radius={"xl"}
              w={130}
            >
              {item.label}
            </Button>
          </Box>
          <Group wrap="nowrap">
            <InputLabel size="md">
              {lang.workflows.program.step_config.more.time_start_from}
            </InputLabel>
            <TimeInput
              name={"time_start_sending_" + item.value.split("_")[1]}
              size="sm"
              disabled={!programData?.[item.value]}
              value={timeStart || timeStartGlobal || programData?.time_start_sending}
              onChange={(e) => handleStartChange(e.target.value)}
            />
          </Group>
          <Group wrap="nowrap">
            <InputLabel size="md">
              {lang.workflows.program.step_config.more.time_start_to}
            </InputLabel>
            <TimeInput
              name={"time_stop_sending_" + item.value.split("_")[1]}
              size="sm"
              disabled={!programData?.[item.value]}
              value={timeStop || timeStopGlobal || programData?.time_stop_sending}
              onChange={(e) => handleStopChange(e.target.value)}
            />
          </Group>
        </Group>

        <DailySchedule
          timeStart={timeStart || timeStartGlobal || programData?.time_start_sending}
          timeStop={timeStop || timeStopGlobal || programData?.time_stop_sending}
          disabled={!programData?.[item.value]}
        />
      </Stack>
    </>
  );
};

export default NewsletterTimeIntervalSettings;
